/* CSN cart extras (cart drawer + cart page)
   1. "Complete your stack" add-on buttons ([data-csn-add]).
   2. Keeps the parts Dawn does not re-render in step with the cart:
      drawer title count, checkout button total, rewards bar, empty state.
      Each re-rendered area carries <span data-csn-state data-count data-total>.
   3. Announces the new total to screen readers after each change.
   4. Cart page: refreshes the add-on strip and the totals after Dawn changes the cart. */
(function () {
  'use strict';
  if (window.__csnCartInit) return;
  window.__csnCartInit = true;

  var LIVE = '[data-csn-live]';

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }
  function sectionIdOf(el) {
    var s = el.closest('.shopify-section');
    return s && s.id.indexOf('shopify-section-') === 0 ? s.id.slice(16) : null;
  }
  function replaceSection(id, html) {
    var current = document.getElementById('shopify-section-' + id);
    if (!current || !html) return;
    var doc = parse(html);
    var fresh = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
    if (fresh) current.innerHTML = fresh.innerHTML;
  }
  function updateBubble(html) {
    var el = document.getElementById('cart-icon-bubble');
    if (!el || !html) return;
    var fresh = parse(html).querySelector('.shopify-section');
    if (fresh) el.innerHTML = fresh.innerHTML;
  }

  /* ---------- screen reader total ---------- */
  var live = null;
  var lastSaid = null;
  function say(text) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.id = 'CsnCartLive';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }
  function announceState(state) {
    if (!state) return;
    var key = state.count + '|' + state.total;
    if (lastSaid === null) { lastSaid = key; return; }
    if (key === lastSaid) return;
    lastSaid = key;
    say(state.count === '0' ? 'Your cart is empty' : 'Cart updated. ' + state.count + (state.count === '1' ? ' item' : ' items') + ', total ' + state.total);
  }
  function readState(scope) {
    var el = scope && scope.querySelector('[data-csn-state]');
    if (!el) return null;
    return {
      count: el.getAttribute('data-count') || '0',
      total: el.getAttribute('data-total') || '',
      cents: el.getAttribute('data-cents') || '',
    };
  }

  /* ---------- drawer sync ---------- */
  var drawerTimer = null;
  var drawerFetching = false;
  function syncDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var state = readState(drawer.querySelector('cart-drawer-items'));
    if (!state) {
      // nothing rendered in cart-drawer-items: empty cart markup
      return;
    }
    var count = parseInt(state.count, 10) || 0;
    var countEl = drawer.querySelector('[data-csn-count]');
    if (countEl && countEl.textContent !== '(' + count + ')') countEl.textContent = '(' + count + ')';
    drawer.querySelectorAll('[data-csn-checkout-total]').forEach(function (el) {
      if (el.textContent !== state.total) el.textContent = state.total;
    });
    var hasEmptyMarkup = !!drawer.querySelector('.drawer__inner-empty');
    if (count > 0 && drawer.classList.contains('is-empty') && !hasEmptyMarkup) drawer.classList.remove('is-empty');
    announceState(state);
  }
  function queueDrawerSync() {
    clearTimeout(drawerTimer);
    drawerTimer = setTimeout(syncDrawer, 120);
    queueVerify();
  }
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__csnWatched) return;
    drawer.__csnWatched = true;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        // ignore our own text updates and Kite's box
        if (t.closest && (t.closest('[data-csn-count]') || t.closest('[data-csn-checkout-total]') || t.closest('.gfgPageWrapper'))) continue;
        queueDrawerSync();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
    var st = readState(drawer.querySelector('cart-drawer-items'));
    if (st) lastSaid = st.count + '|' + st.total;
  }
  // Re-fetch the whole drawer when the cart changed somewhere Dawn does not re-render it
  // (for example a third-party app adding to the cart).
  function refetchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawerFetching) return;
    drawerFetching = true;
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) { renderDrawer(sections); })
      .catch(function () {})
      .finally(function () { drawerFetching = false; });
  }
  function renderDrawer(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !sections) return;
    var html = sections['cart-drawer'];
    if (html) {
      var doc = parse(html);
      var fresh = doc.querySelector('.drawer__inner');
      var current = drawer.querySelector('.drawer__inner');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      var freshDrawer = doc.querySelector('cart-drawer');
      if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
    }
    updateBubble(sections['cart-icon-bubble']);
  }

  /* ---------- cart page sync ---------- */
  var pageFetching = false;
  function syncPage() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    var itemsState = readState(document.getElementById('main-cart-items'));
    var footerState = readState(footer);
    // Items were re-rendered by someone else (for example the Kite app after a claim or
    // after it removed the gift): bring the totals, rewards bar and add-ons up to date.
    if (itemsState && footerState && (itemsState.count !== footerState.count || itemsState.total !== footerState.total)) {
      refreshPageExtras();
      return;
    }
    var state = footerState || itemsState;
    if (!state) return;
    footer.querySelectorAll('[data-csn-checkout-total]').forEach(function (el) {
      if (el.textContent !== state.total) el.textContent = state.total;
    });
    announceState(state);
  }
  function refreshPageExtras() {
    var footer = document.getElementById('main-cart-footer');
    var footerId = footer && footer.getAttribute('data-id');
    if (!footerId || pageFetching) return;
    var ids = [footerId];
    document.querySelectorAll('#MainContent ' + LIVE).forEach(function (el) {
      var id = sectionIdOf(el);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    pageFetching = true;
    fetch(window.location.pathname + '?sections=' + ids.join(','), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        replaceFooterContents(data[footerId]);
        ids.slice(1).forEach(function (id) { replaceSection(id, data[id]); });
      })
      .catch(function () {})
      .finally(function () {
        pageFetching = false;
        var itemsState = readState(document.getElementById('main-cart-items'));
        var footerState = readState(document.getElementById('main-cart-footer'));
        var state = footerState || itemsState;
        if (state) {
          document.querySelectorAll('#main-cart-footer [data-csn-checkout-total]').forEach(function (el) {
            if (el.textContent !== state.total) el.textContent = state.total;
          });
          announceState(state);
        }
      });
  }
  var pageTimer = null;
  function watchPage() {
    var main = document.getElementById('MainContent');
    var footer = document.getElementById('main-cart-footer');
    if (!main || !footer || main.__csnWatched) return;
    main.__csnWatched = true;
    var st = readState(footer);
    if (st) lastSaid = st.count + '|' + st.total;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.closest && t.closest('[data-csn-checkout-total]')) continue;
        clearTimeout(pageTimer);
        pageTimer = setTimeout(syncPage, 120);
        queueVerify();
        return;
      }
    }).observe(main, { childList: true, subtree: true });
  }
  function cartPageIds() {
    var ids = [];
    document.querySelectorAll('#MainContent cart-items, #MainContent #main-cart-footer, #MainContent ' + LIVE).forEach(function (el) {
      var id = sectionIdOf(el);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids.slice(0, 4);
  }
  function replaceFooterContents(html) {
    var footer = document.getElementById('main-cart-footer');
    if (!footer || !html) return;
    var fresh = parse(html).querySelector('#main-cart-footer .js-contents');
    var current = footer.querySelector('.js-contents');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var freshFooter = parse(html).getElementById('main-cart-footer');
    if (freshFooter) footer.classList.toggle('is-empty', freshFooter.classList.contains('is-empty'));
  }

  /* ---------- check against the real cart ----------
     Apps (Kite free gift) sometimes change the cart and re-render only part of it.
     After any change we compare what is on screen with /cart.js and re-render if needed. */
  var verifyTimer = null;
  function queueVerify() {
    clearTimeout(verifyTimer);
    verifyTimer = setTimeout(verify, 450);
  }
  function differs(state, cart) {
    if (!state) return false;
    return String(cart.item_count) !== state.count || (state.cents !== '' && String(cart.total_price) !== state.cents);
  }
  function verify() {
    if (drawerFetching || pageFetching) { queueVerify(); return; }
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          var ds = readState(drawer.querySelector('cart-drawer-items'));
          var showsEmpty = !!drawer.querySelector('.drawer__inner-empty');
          if (differs(ds, cart) || (!ds && cart.item_count > 0) || (showsEmpty && cart.item_count > 0)) refetchDrawer();
        }
        var footer = document.getElementById('main-cart-footer');
        if (footer) {
          var fs = readState(footer);
          var is = readState(document.getElementById('main-cart-items'));
          if (differs(is, cart) || (!is && cart.item_count > 0)) {
            refreshPageItems();
          } else if (differs(fs, cart) || (!fs && cart.item_count > 0)) {
            refreshPageExtras();
          }
        }
      })
      .catch(function () {});
  }
  function refreshPageItems() {
    var items = document.getElementById('main-cart-items');
    var id = items && items.getAttribute('data-id');
    if (!id || pageFetching) return;
    pageFetching = true;
    fetch(window.location.pathname + '?sections=' + id, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var fresh = data[id] && parse(data[id]).querySelector('#main-cart-items .js-contents');
        var current = items.querySelector('.js-contents');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var freshCartItems = data[id] && parse(data[id]).querySelector('cart-items');
        var cartItems = document.querySelector('#MainContent cart-items');
        if (freshCartItems && cartItems) cartItems.classList.toggle('is-empty', freshCartItems.classList.contains('is-empty'));
      })
      .catch(function () {})
      .finally(function () {
        pageFetching = false;
        refreshPageExtras();
      });
  }

  /* ---------- add-on buttons ---------- */
  function announce(scope, text) {
    var status = scope && scope.querySelector('.csn-addons__status');
    if (status) status.textContent = text;
  }
  function publishUpdate(cartData) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      // source 'cart-items' stops Dawn components from re-fetching what we already rendered
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', csn: true, cartData: cartData });
    }
    document.dispatchEvent(new CustomEvent('csn:cart:updated', { detail: cartData }));
  }
  function addOn(btn) {
    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId || btn.disabled) return;
    var inDrawer = !!btn.closest('cart-drawer');
    var pageIds = inDrawer ? [] : cartPageIds();
    var sections = inDrawer ? ['cart-drawer', 'cart-icon-bubble'] : pageIds.concat('cart-icon-bubble');
    var labelHTML = btn.innerHTML;
    var scope = btn.closest('.csn-addons');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.textContent = 'Adding';

    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
          return data;
        });
      })
      .then(function (data) {
        var title = data.items && data.items[0] ? data.items[0].product_title : 'Item';
        if (inDrawer) {
          renderDrawer(data.sections);
          var drawer = document.querySelector('cart-drawer');
          var target = drawer && (drawer.querySelector('.csn-addon__btn') || drawer.querySelector('#CartDrawer-Checkout'));
          if (target) target.focus({ preventScroll: true });
          announce(drawer, title + ' added to cart');
        } else {
          sections.forEach(function (id) {
            if (id === 'cart-icon-bubble') updateBubble(data.sections && data.sections[id]);
            else replaceSection(id, data.sections && data.sections[id]);
          });
          announce(document.querySelector('#MainContent .csn-addons'), title + ' added to cart');
        }
        publishUpdate(data);
      })
      .catch(function () {
        btn.textContent = 'Sold out';
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        announce(scope, 'Sorry, that item could not be added');
        setTimeout(function () {
          btn.innerHTML = labelHTML;
          btn.disabled = false;
        }, 2500);
      });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-csn-add]');
    if (!btn) return;
    e.preventDefault();
    addOn(btn);
  });

  /* ---------- Dawn cart events ---------- */
  var pending = null;
  function onCartUpdate(evt) {
    queueVerify();
    if (evt && evt.csn) return;
    var onCartPage = !!document.getElementById('main-cart-footer');
    if (!onCartPage) return;
    var empty = !!(evt && evt.cartData && evt.cartData.item_count === 0);
    document.querySelectorAll('#MainContent ' + LIVE).forEach(function (el) {
      el.classList.toggle('is-cart-empty', empty);
    });
    var liveIds = [];
    document.querySelectorAll('#MainContent ' + LIVE).forEach(function (el) {
      var id = sectionIdOf(el);
      if (id && liveIds.indexOf(id) === -1) liveIds.push(id);
    });
    var footer = document.getElementById('main-cart-footer');
    var footerId = footer && footer.getAttribute('data-id');
    // Dawn already re-rendered the totals after its own quantity change
    var needFooter = footerId && evt && evt.source !== 'cart-items';
    var ids = liveIds.slice();
    if (needFooter) ids.push(footerId);
    if (!ids.length) return;
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch(window.location.pathname + '?sections=' + ids.join(','), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          liveIds.forEach(function (id) { replaceSection(id, data[id]); });
          if (needFooter) replaceFooterContents(data[footerId]);
          syncPage();
        })
        .catch(function () {});
    }, 150);
  }
  function hook() {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
      return true;
    }
    return false;
  }

  function init() {
    if (!hook()) setTimeout(hook, 500);
    watchDrawer();
    watchPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Helper for other scripts: re-render the drawer from the server
  // (window.csnCartRefresh() or document.dispatchEvent(new Event('csn:cart:refresh'))).
  // Kite already re-renders the drawer itself after a claim, so it does not need this.
  document.addEventListener('csn:cart:refresh', refetchDrawer);
  window.csnCartRefresh = refetchDrawer;
})();
